import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { EligibilityResponse } from "src/app/interfaces/ApiResponse";

interface DialogProps {
  visible: boolean;
  onClose: () => void;
  onVerify: () => void; // ✅ FIXED
  header?: string;
  cardNumber: string | null;
  data: EligibilityResponse | null;
}

const VerifyCardDialog: React.FC<DialogProps> = ({
  visible,
  onClose,
  onVerify,
  header,
  cardNumber,
  data
}) => {
  const toast = useRef<Toast>(null);
  const { t } = useTranslation();

  const handleHide = () => {
    onClose();
  };

  return (
    <>
      <Toast ref={toast} />
      <Dialog
        style={{ width: '35vw' }}
        breakpoints={{ '960px': '75vw', '641px': '100vw' }}
        visible={visible}
        onHide={handleHide}
        dismissableMask
        closable={false}
      >
        <div className="text-center">
          <i className="pi pi-check-circle" style={{ color: '#22C55E', fontSize: '2.5rem' }} />

          <h3 className="mb-3 text-center font-bold">{t('landing.esim_eligibility.verify_your_card')}</h3>

          <p className="mb-5 text-center">
            {/* {t('landing.esim_eligibility.verify_your_card_title')} */}
            {data?.message}
          </p>

          <p className="mb-5 text-center">
            {t('landing.esim_eligibility.verify_your_card_description')}

          </p>

          <div className="flex gap-2">
            <Button
              className="w-full"
              label={t('landing.esim_eligibility.not_now_button')}
              severity="secondary"
              outlined
              onClick={handleHide}
            />

            <Button
              className="w-full"
              label={t('landing.esim_eligibility.verify_card')}
              onClick={onVerify} // ✅ IMPORTANT
            />
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default VerifyCardDialog;